<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";
import moment from "moment";
import DatePicker from "vue2-datepicker";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect, DatePicker },
    props: {
        eventoCodigo: {
            type: [String, Number],
            default: null
        },
        allowRedirect: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            title: "Evento-Laborantes",
            items: [
                {
                text: "Eventos",
                href: "/"
                },
                {
                text: "Agregar Laborantes",
                active: true
                }
            ],
            evento:'',
            eventoid_seleccion:{},
            laborantes:[],
            status:'',
            apoyo:[
                {
                    laborante:[],
                    hora_inicio:'',
                    hora_fin:'',
                }
            ],
            relator:[
                {
                    laborante:'',
                    evento:'',
                    hora_inicio:'',
                    hora_fin:'',
                    fecha:'',
                    tipo:'Relator'
                }
            ],
            laborante:null,
            apoyo_pagado:[],
            relator_pagado:[],
            liquido:0,
            tipos:[],
            subtipos:[],
            editandoLaborante: null,
            guardandoEdicion: false,
        };
    },
    watch:{
        eventoCodigo(nuevoCodigo, anteriorCodigo) {
            if (nuevoCodigo && nuevoCodigo !== anteriorCodigo) {
                this.cargarEvento(nuevoCodigo);
            }
        },
        // Observar cambios en el array completo
        apoyo: {
            handler() {
                this.verificarCampos_apoyo();
            },
            deep: true // Para detectar cambios en los objetos dentro del array
        },
        relator: {
            handler() {
                this.verificarCampos_relator();
            },
            deep: true // Para detectar cambios en los objetos dentro del array
        }
    },
    methods:{
        cargarEvento(codigo) {
            this.evento = codigo;
            axios.get(`/api/get_evento/${codigo}`).then(response => {
                if(response.data.estado){
                    this.eventoid_seleccion = response.data.evento;
                    this.cargarLaborantes();
                }
            });
        },
        cargarLaborantes() {
            axios.get(`/api/get_laborantes_evento/${this.eventoid_seleccion.codigo}`).then(response => {
                if(this.apoyo.length==0){
                    this.agregar_lab_apoyo();
                }
                if(this.relator.length==0){
                    this.agregar_lab_relator();
                }
                if (this.user.rol=='Admin') {
                    this.apoyo_pagado= response.data.apoyo_pagado;
                    this.relator_pagado= response.data.relator_pagado;
                }else if(this.user.rol=='Supervisor'){
                    this.apoyo_pagado= response.data.apoyo_pagado.filter((us) => this.obtenerLabotante(us.laborante_id).sede == this.user.sede);
                    this.relator_pagado= response.data.relator_pagado.filter((us) => this.obtenerLabotante(us.laborante_id).sede == this.user.sede);
                }else{
                    this.apoyo_pagado= response.data.apoyo_pagado.filter((us) => us.user_id == this.user.id);
                    this.relator_pagado= response.data.relator_pagado.filter((us) => us.user_id == this.user.id);
                }
            });
        },
        verificarCampos_apoyo() {
            this.apoyo.forEach((lab, index) => {
                if (lab.laborante && lab.hora_inicio && lab.hora_fin) {
                    const laborante_id = lab.laborante.id || lab.laborante_id;
                    if (!laborante_id) {
                        this.msg('error', 'Error: El laborante seleccionado no tiene ID.');
                        return;
                    }
                    const formData = new FormData();
                    formData.append('laborante_id', laborante_id);
                    formData.append('fecha', this.eventoid_seleccion.fecha_inicio);
                    formData.append('hora_inicio', lab.hora_inicio);
                    formData.append('hora_fin', lab.hora_fin);
                    axios.post('/api/revisar_choque_horario_laborante', formData).then(response => {
                        if (!response.data.estado) {
                            this.msg('error', 'El laborante ya tiene horas asignadas en este horario.');
                            console.log('El laborante ya tiene horas asignadas en este horario.');
                            lab.hora_inicio = '';
                            lab.hora_fin = '';
                        }
                    })
                    .catch(() => {
                        this.msg('error', 'Error al verificar choque de horario.');
                        console.log('Error al verificar choque de horario.');

                    });
                }
            });
        },
        verificarCampos_relator() {
            this.relator.forEach((lab, index) => {
                if (lab.laborante && lab.hora_inicio && lab.hora_fin) {
                    const laborante_id = lab.laborante.id || lab.laborante_id;
                    if (!laborante_id) {
                        this.msg('error', 'Error: El laborante seleccionado no tiene ID.');
                        return;
                    }
                    const formData = new FormData();
                    formData.append('laborante_id', laborante_id);
                    formData.append('fecha', this.eventoid_seleccion.fecha_inicio);
                    formData.append('hora_inicio', lab.hora_inicio);
                    formData.append('hora_fin', lab.hora_fin);
                    axios.post('/api/revisar_choque_horario_laborante', formData).then(response => {
                        if (!response.data.estado) {
                            this.msg('error', 'El laborante ya tiene horas asignadas en este horario.');
                            console.log('El laborante ya tiene horas asignadas en este horario.');
                            lab.hora_inicio = '';
                            lab.hora_fin = '';
                        }
                    })
                    .catch(() => {
                        this.msg('error', 'Error al verificar choque de horario.');
                        console.log('Error al verificar choque de horario.');

                    });
                }
            });
        },
        labelselect_laborante ({ name }) {
            return `${name}`
        },
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        normalizeLaboranteRows(rows) {
            return (rows || []).filter((row) => {
                const laboranteId = row && row.laborante ? (row.laborante.id || row.laborante_id) : null;
                return !!laboranteId || !!row.hora_inicio || !!row.hora_fin;
            });
        },
        validarLaborantes(rows, tipoLaborante) {
            if (!this.eventoid_seleccion || !this.eventoid_seleccion.id) {
                return 'Debe seleccionar un evento valido antes de guardar laborantes.';
            }

            const registros = this.normalizeLaboranteRows(rows);
            if (!registros.length) {
                return `No hay laborantes de ${tipoLaborante.toLowerCase()} para guardar.`;
            }

            const repetidos = new Set();
            const vistos = new Set();
            const existentes = new Set(
                (tipoLaborante === 'Apoyo' ? this.apoyo_pagado : this.relator_pagado)
                    .map((item) => Number(item.laborante_id))
                    .filter((id) => !!id)
            );

            for (let index = 0; index < registros.length; index += 1) {
                const row = registros[index];
                const numero = index + 1;
                const laboranteId = row && row.laborante ? Number(row.laborante.id || row.laborante_id) : null;

                if (!laboranteId) {
                    return `La fila ${numero} no tiene un laborante seleccionado.`;
                }

                if (!row.hora_inicio || !row.hora_fin) {
                    return `La fila ${numero} debe tener hora de inicio y hora de fin.`;
                }

                if (row.hora_inicio >= row.hora_fin) {
                    return `La fila ${numero} tiene una hora de termino menor o igual a la hora de inicio.`;
                }

                if (existentes.has(laboranteId)) {
                    return `El laborante de la fila ${numero} ya fue agregado como ${tipoLaborante.toLowerCase()} en este evento.`;
                }

                if (vistos.has(laboranteId)) {
                    repetidos.add(numero);
                }
                vistos.add(laboranteId);
            }

            if (repetidos.size) {
                return `Hay laborantes repetidos en las filas: ${Array.from(repetidos).join(', ')}.`;
            }

            return null;
        },
        agregar_lab_apoyo(){
            let a={
                laborante:[],
                hora_inicio:'',
                hora_fin:'',
            };
            this.apoyo.push(a);
        },
        eliminar_apoyo(index){
            this.apoyo.splice(index, 1);
        },
        guardar_apoyo(){
            const error = this.validarLaborantes(this.apoyo, 'Apoyo');
            if (error) {
                this.msg('error', error);
                return;
            }

            this.apoyo = this.normalizeLaboranteRows(this.apoyo);
            let formData = new FormData();
            formData.append('apoyo', JSON.stringify(this.apoyo));
            formData.append('evento_id', this.eventoid_seleccion.id);
            formData.append('fecha', this.eventoid_seleccion.fecha_inicio);
            axios.post('/api/guardar_laborantes_apoyo', formData).then(response => {
                this.actualizar()
                this.msg('success','Se han guardado los laborantes de apoyo.');
            }).catch((errorResponse) => {
                this.msg('error', errorResponse?.response?.data?.mensaje || 'No se pudieron guardar los laborantes de apoyo.');
            });

        },
        agregar_lab_relator(){
            let a={
                laborante:[],
                hora_inicio:'',
                hora_fin:'',
            };
            this.relator.push(a);
        },
        eliminar_relator(index){
            this.relator.splice(index, 1);
        },
        guardar_relator(){
            const error = this.validarLaborantes(this.relator, 'Relator');
            if (error) {
                this.msg('error', error);
                return;
            }

            this.relator = this.normalizeLaboranteRows(this.relator);
            let formData = new FormData();
            formData.append('relator', JSON.stringify(this.relator));
            formData.append('evento_id', this.eventoid_seleccion.id);
            formData.append('fecha', this.eventoid_seleccion.fecha_inicio);
            axios.post('/api/guardar_laborantes_relator', formData).then(response => {
                this.actualizar()
                this.msg('success','Se han guardado laborantes relator.');
            }).catch((errorResponse) => {
                this.msg('error', errorResponse?.response?.data?.mensaje || 'No se pudieron guardar los relatores.');
            });
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
        obtenerLabotante(element){
            let laborante = this.laborantes.filter((us) => us.id==element);
            if (laborante.length>0) {
                return laborante[0];
            }
        },
        actualizar(){
            axios.get(`/api/get_laborantes_evento/${this.eventoid_seleccion.codigo}`).then(response => {
                //this.apoyo= response.data.apoyo;
                this.relator=[];
                this.apoyo=[];
                if(this.apoyo.length==0){
                    this.agregar_lab_apoyo();
                }
                if(this.relator.length==0){
                    this.agregar_lab_relator();
                }
                if (this.user.rol=='Admin') {
                    this.apoyo_pagado= response.data.apoyo_pagado;
                    this.relator_pagado= response.data.relator_pagado;
                    console.log(this.apoyo_pagado);
                    console.log(this.relator_pagado);

                }else if(this.user.rol=='Supervisor'){
                    this.apoyo_pagado= response.data.apoyo_pagado.filter((us) => this.obtenerLabotante(us.laborante_id).sede == this.user.sede);
                    this.relator_pagado= response.data.relator_pagado.filter((us) => this.obtenerLabotante(us.laborante_id).sede == this.user.sede);
                }else{
                    this.apoyo_pagado= response.data.apoyo_pagado.filter((us) => us.user_id == this.user.id);
                    this.relator_pagado= response.data.relator_pagado.filter((us) => us.user_id == this.user.id);
                }
            });
        },
        valorpago(lab){
            axios.get('/api/get_pagos_periodo/'+lab.id).then(response => {
                this.liquido = response.data.total_liquido
                if (this.liquido>=250000) {
                    Swal.fire({
                        //position: "top-end",
                        icon: 'warning',
                        title: 'Laborante alcanzó limite de $250.000 en periodo '+this.formatFecha(response.data.inicio)+' al '+this.formatFecha(response.data.fin) ,
                        text: 'Tener en consideración para próximas actividades.',
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#C87838"
                        //showConfirmButton: false,
                        //timer: 5000
                    });
                }
            });
        },
        abrirModalEdicion(item) {
            this.editandoLaborante = {
                id: item.id,
                tipo_laborante: item.tipo_laborante,
                fecha: item.fecha,
                hora_inicio: item.hora_inicio,
                hora_fin: item.hora_fin,
            };
            this.$refs.modalEditarLaborante.show();
        },
        guardarEdicionLaborante() {
            if (!this.editandoLaborante || !this.editandoLaborante.id) {
                this.msg('error', 'No se pudo identificar el registro a editar.');
                return;
            }

            if (!this.editandoLaborante.fecha || !this.editandoLaborante.hora_inicio || !this.editandoLaborante.hora_fin) {
                this.msg('error', 'Debe completar fecha, hora de inicio y hora de fin.');
                return;
            }

            if (this.editandoLaborante.hora_inicio >= this.editandoLaborante.hora_fin) {
                this.msg('error', 'La hora de inicio debe ser menor que la hora de fin.');
                return;
            }

            this.guardandoEdicion = true;
            const formData = new FormData();
            formData.append('pago_id', this.editandoLaborante.id);
            formData.append('fecha', this.editandoLaborante.fecha);
            formData.append('hora_inicio', this.editandoLaborante.hora_inicio);
            formData.append('hora_fin', this.editandoLaborante.hora_fin);

            axios.post('/api/editar_pagar', formData).then((response) => {
                if (!response.data || !response.data.estado) {
                    throw new Error((response.data && response.data.mensaje) ? response.data.mensaje : 'No se pudo editar el registro.');
                }

                this.$refs.modalEditarLaborante.hide();
                this.actualizar();
                this.msg('success', 'Registro actualizado correctamente.');
            }).catch((errorResponse) => {
                this.msg('error', errorResponse?.response?.data?.mensaje || errorResponse?.message || 'No se pudo editar el registro.');
            }).finally(() => {
                this.guardandoEdicion = false;
            });
        },
        eliminarLaboranteAgregado(item) {
            if (!item || !item.id) {
                this.msg('error', 'No se pudo identificar el registro a eliminar.');
                return;
            }

            Swal.fire({
                icon: 'warning',
                title: 'Eliminar registro',
                text: 'Esta acción eliminará este laborante agregado del evento.',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#d33',
            }).then((result) => {
                if (!result.isConfirmed) {
                    return;
                }

                const formData = new FormData();
                formData.append('pago_id', item.id);

                axios.post('/api/eliminar_pagar', formData).then((response) => {
                    if (!response.data || !response.data.estado) {
                        throw new Error((response.data && response.data.mensaje) ? response.data.mensaje : 'No se pudo eliminar el registro.');
                    }

                    this.actualizar();
                    this.msg('success', 'Registro eliminado correctamente.');
                }).catch((errorResponse) => {
                    this.msg('error', errorResponse?.response?.data?.mensaje || errorResponse?.message || 'No se pudo eliminar el registro.');
                });
            });
        }
    },
    mounted(){
        axios.get('/api/get_laborantes').then(response => {
            if (this.user.rol=='Admin') {
                this.laborantes= response.data.usuarios;
            }else {
                this.laborantes= response.data.usuarios.filter((us) => us.sede==this.user.sede);
            }
        });
        axios.get('/api/get_tipos').then(res=>{
            this.tipos=res.data.tipos
            this.subtipos=res.data.subtipos
        });
    },
    created(){
        if (this.eventoCodigo) {
            this.cargarEvento(this.eventoCodigo);
            return;
        }
        if (localStorage.getItem("evento_codigo")) {
            const evento = localStorage.getItem("evento_codigo");
            this.evento = evento;
            localStorage.removeItem("evento_codigo");
            this.cargarEvento(evento);
            return;
        }
        if (this.allowRedirect) {
            window.location.href = "/web/configuracion/eventosiniciados";
        }
    }
};
</script>
<template>
    <!-- <Layout>
        <PageHeader :title="title" :items="items" /> -->
        <div class="row laborantes-evento-tab">
            <div class="col-md-12">
                <div class="laborantes-evento-shell">
                    <div class="laborantes-evento-body">
                        <div class="row">
                            <!-- <div class="col-md-12 mb-3">
                                <h1 class="text-primary mb-4">{{ eventoid_seleccion.nombre_difusion }}</h1>
                                <h3 class="text-primary mb-4">{{ eventoid_seleccion.colegio }}</h3>
                            </div>
                            <div class="col-md-6">
                                <p class="font-size-16"><strong>Actividad:</strong> {{ eventoid_seleccion.nombre_difusion }}</p>
                                <p class="font-size-16"><strong>Código:</strong> {{ eventoid_seleccion.codigo }}</p>
                                <p class="font-size-16"><strong>Fecha Inicio:</strong> {{ eventoid_seleccion.fecha_inicio }}</p>
                                <p class="font-size-16"><strong>Fecha de término:</strong> {{ eventoid_seleccion.fecha_termino }}</p>
                                <p class="font-size-16"><strong>Tipo:</strong> {{ tipos.find((us)=> us.codigo==eventoid_seleccion.tipo_codigo).nombre }}</p>
                                <p class="font-size-16"><strong>SubTipo:</strong> {{ subtipos.find((us)=> us.codigo==eventoid_seleccion.subtipo_codigo).nombre }}</p>
                            </div>
                            <div class="col-md-6">
                                <p class="font-size-16"><strong>Nombre para Difusión Digital:</strong> {{ eventoid_seleccion.nombre_difusion }}</p>
                                <p class="font-size-16"><strong>Sede Asociada:</strong> {{ eventoid_seleccion.sede_asociada }}</p>
                                <p class="font-size-16"><strong>Cantidad Inscripciones:</strong> {{ eventoid_seleccion.cantidad_inscripciones }}</p>
                                <p class="font-size-16"><strong>Nº Asistentes:</strong> {{ eventoid_seleccion.num_asistentes }}</p>
                                <p class="font-size-16"><strong>Propietario:</strong> {{ eventoid_seleccion.propietario }}</p>

                            </div> -->
                            <div class="col-12 laborantes-section-card laborantes-section-card--support">
                                <h5 class="laborantes-section-title">Agregar Laborantes Apoyo</h5>
                                <div class="row laborantes-entry-row" v-for="(lab,index) in apoyo" :key="index">
                                    <div class="col-12 col-lg-4 laborantes-field-col laborantes-field-col--laborante">
                                        <div class="form-group laborantes-form-group">
                                            <div class="laborantes-label-row">
                                                <label for="pais"> Laborante:</label>
                                                <label for="pais" class="laborantes-required"> * Obligatorio</label>
                                            </div>
                                            <div class="laborantes-control-wrap">
                                                <multiselect
                                                    v-model="lab.laborante"
                                                    :options="laborantes"
                                                    placeholder="Seleccionar laborante"
                                                    selectLabel="Presiona para seleccionar"
                                                    selectedLabel="Seleccionado"
                                                    deselectLabel="Presiona para remover"
                                                    :custom-label="labelselect_laborante"
                                                    @select="valorpago"
                                                    >
                                                    <template v-slot:noOptions>
                                                        <p>No hay opciones</p>
                                                    </template>
                                                    <template v-slot:noResult>
                                                        <p>No se encuentra coincidencia</p>
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-3 laborantes-field-col laborantes-field-col--time">
                                        <div class="form-group laborantes-form-group">
                                            <div class="laborantes-label-row">
                                                <label for="pais"> Hora inicio:</label>
                                                <label for="pais" class="laborantes-required"> * Obligatorio</label>
                                            </div>
                                            <div class="laborantes-control-wrap laborantes-time-field">
                                                <date-picker v-model="lab.hora_inicio" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-3 laborantes-field-col laborantes-field-col--time">
                                        <div class="form-group laborantes-form-group">
                                            <div class="laborantes-label-row">
                                                <label for="pais"> Hora fin:</label>
                                                <label for="pais" class="laborantes-required"> * Obligatorio</label>
                                            </div>
                                            <div class="laborantes-control-wrap laborantes-time-field">
                                                <date-picker v-model="lab.hora_fin" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-1 laborantes-delete-col">
                                        <b-button variant="danger" class="laborantes-delete-btn" @click="eliminar_apoyo(index)"><i class="bx bx-trash"></i></b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 text-right mb-3 laborantes-actions-row">
                                        <b-button class="laborantes-secondary-btn" variant="primary" @click="agregar_lab_apoyo"><i class="bx bx-plus"></i> Laborante</b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 mb-3">
                                        <b-button class="laborantes-primary-btn" variant="primary" block @click="guardar_apoyo()">Guardar Laborantes de Apoyo</b-button>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 laborantes-toggle-row">
                                <div class="row">
                                    <div class="col-md-6 mt-4">
                                        <b-form-checkbox id="checkbox-1" v-model="status" name="checkbox-1" > Relator </b-form-checkbox>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 mt-3 laborantes-section-card laborantes-section-card--relator" v-if="status">
                                <h5 class="laborantes-section-title">Agregar Relator</h5>
                                <div class="row laborantes-entry-row" v-for="(lab,index) in relator" :key="index">
                                    <div class="col-12 col-lg-4 laborantes-field-col laborantes-field-col--laborante">
                                        <div class="form-group laborantes-form-group">
                                            <div class="laborantes-label-row">
                                                <label for="pais"> Laborante:</label>
                                                <label for="pais" class="laborantes-required"> * Obligatorio</label>
                                            </div>
                                            <div class="laborantes-control-wrap">
                                                <multiselect
                                                    v-model="lab.laborante"
                                                    :options="laborantes"
                                                    placeholder="Seleccionar laborante"
                                                    selectLabel="Presiona para seleccionar"
                                                    selectedLabel="Seleccionado"
                                                    deselectLabel="Presiona para remover"
                                                    :custom-label="labelselect_laborante"
                                                    >
                                                    <template v-slot:noOptions>
                                                        <p>No hay opciones</p>
                                                    </template>
                                                    <template v-slot:noResult>
                                                        <p>No se encuentra coincidencia</p>
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-3 laborantes-field-col laborantes-field-col--time">
                                        <div class="form-group laborantes-form-group">
                                            <div class="laborantes-label-row">
                                                <label for="pais"> Hora inicio:</label>
                                                <label for="pais" class="laborantes-required"> * Obligatorio</label>
                                            </div>
                                            <div class="laborantes-control-wrap laborantes-time-field">
                                                <date-picker v-model="lab.hora_inicio" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-3 laborantes-field-col laborantes-field-col--time">
                                        <div class="form-group laborantes-form-group">
                                            <div class="laborantes-label-row">
                                                <label for="pais"> Hora fin:</label>
                                                <label for="pais" class="laborantes-required"> * Obligatorio</label>
                                            </div>
                                            <div class="laborantes-control-wrap laborantes-time-field">
                                                <date-picker v-model="lab.hora_fin" type="time" value-type="format" format="HH:mm" :first-day-of-week="2" lang="es" ></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-1 laborantes-delete-col">
                                        <b-button variant="danger" class="laborantes-delete-btn" @click="eliminar_relator(index)"><i class="bx bx-trash"></i></b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 text-right mb-3 laborantes-actions-row">
                                        <b-button class="laborantes-secondary-btn" variant="primary" @click="agregar_lab_relator"><i class="bx bx-plus"></i> Laborante</b-button>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 mb-3">
                                        <b-button class="laborantes-primary-btn" variant="primary" block @click="guardar_relator()">Guardar Relator(es)</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3" v-if="apoyo_pagado.length>0 || relator_pagado.length>0">
                            <div class="col-md-12">
                                <h5 class="laborantes-section-title laborantes-section-title--list">Laborantes ya agregados</h5>
                                <div class="table-responsive mb-0 mt-3 laborantes-table-wrap">
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <th style="width: 20%;">Nombre</th>
                                                <th style="width: 10%;">RUT</th>
                                                <th style="width: 10%;">Sede</th>
                                                <th style="width: 10%;">Tipo</th>
                                                <th style="width: 10%;">Fecha</th>
                                                <th style="width: 10%;">Hora inicio</th>
                                                <th style="width: 10%;">Hora fin</th>
                                                <th style="width: 20%;" v-if="user.rol=='Supervisor'">Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in apoyo_pagado" :key="index">
                                                <td>{{ obtenerLabotante(item.laborante_id).name }}</td>
                                                <td>{{ obtenerLabotante(item.laborante_id).rut }}</td>
                                                <td>{{ obtenerLabotante(item.laborante_id).sede }}</td>
                                                <td>{{ item.tipo_laborante }}</td>
                                                <td>{{ formatFecha(item.fecha) }}</td>
                                                <td>{{ item.hora_inicio }}</td>
                                                <td>{{ item.hora_fin }}</td>
                                                <td v-if="user.rol=='Supervisor'">
                                                    <b-button size="sm" variant="warning" class="mr-2" @click="abrirModalEdicion(item)">
                                                        Editar
                                                    </b-button>
                                                    <b-button size="sm" variant="danger" @click="eliminarLaboranteAgregado(item)">
                                                        Eliminar
                                                    </b-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr v-for="(item, index) in relator_pagado" :key="index">
                                                <td>{{ obtenerLabotante(item.laborante_id).name }}</td>
                                                <td>{{ obtenerLabotante(item.laborante_id).rut }}</td>
                                                <td>{{ obtenerLabotante(item.laborante_id).sede }}</td>
                                                <td>{{ item.tipo_laborante }}</td>
                                                <td>{{ formatFecha(item.fecha) }}</td>
                                                <td>{{ item.hora_inicio }}</td>
                                                <td>{{ item.hora_fin }}</td>
                                                <td v-if="user.rol=='Supervisor'">
                                                    <b-button size="sm" variant="warning" class="mr-2" @click="abrirModalEdicion(item)">
                                                        Editar
                                                    </b-button>
                                                    <b-button size="sm" variant="danger" @click="eliminarLaboranteAgregado(item)">
                                                        Eliminar
                                                    </b-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <b-modal
                            ref="modalEditarLaborante"
                            title="Editar laborante agregado"
                            ok-title="Guardar cambios"
                            cancel-title="Cancelar"
                            @ok.prevent="guardarEdicionLaborante"
                            :ok-disabled="guardandoEdicion"
                        >
                            <div v-if="editandoLaborante">
                                <b-form-group label="Fecha">
                                    <date-picker
                                        v-model="editandoLaborante.fecha"
                                        value-type="YYYY-MM-DD"
                                        format="DD-MM-YYYY"
                                        :first-day-of-week="2"
                                        lang="es"
                                    ></date-picker>
                                </b-form-group>
                                <b-form-group label="Hora inicio">
                                    <date-picker
                                        v-model="editandoLaborante.hora_inicio"
                                        type="time"
                                        value-type="format"
                                        format="HH:mm"
                                        :first-day-of-week="2"
                                        lang="es"
                                    ></date-picker>
                                </b-form-group>
                                <b-form-group label="Hora fin">
                                    <date-picker
                                        v-model="editandoLaborante.hora_fin"
                                        type="time"
                                        value-type="format"
                                        format="HH:mm"
                                        :first-day-of-week="2"
                                        lang="es"
                                    ></date-picker>
                                </b-form-group>
                            </div>
                        </b-modal>
                    </div>
                </div>
            </div>
        </div>
    <!-- </Layout> -->
</template>

<style scoped>
.laborantes-evento-shell {
    margin-top: 0.75rem;
}

.laborantes-evento-body {
    padding: 1.25rem 1rem 1.5rem;
}

.laborantes-section-card {
    border: 1px solid #e6ebf2;
    border-radius: 0.9rem;
    background: #fff;
    box-shadow: 0 8px 24px rgba(37, 44, 76, 0.05);
    padding: 1.15rem 1rem 0.6rem;
}

.laborantes-section-title {
    color: #c97e37;
    font-size: 1.05rem;
    font-weight: 400;
    margin-bottom: 1rem;
}

.laborantes-section-title--list {
    margin-left: 0.25rem;
}

.laborantes-form-group {
    margin-bottom: 0.9rem;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.laborantes-form-group label {
    color: #4c5565;
    font-weight: 700;
    margin-bottom: 0.4rem;
}

.laborantes-label-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 0.75rem;
}

.laborantes-control-wrap {
    width: 100%;
}

.laborantes-required {
    color: #c97e37 !important;
    font-weight: 400 !important;
}

.laborantes-entry-row {
    display: grid;
    grid-template-columns: minmax(260px, 1.7fr) minmax(170px, 1fr) minmax(170px, 1fr) auto;
    align-items: end;
    column-gap: 1rem;
    row-gap: 0.35rem;
    margin: 0 0 0.65rem;
}

.laborantes-entry-row > [class*="col-"] {
    width: 100%;
    max-width: none;
    flex: none;
    padding-right: 0;
    padding-left: 0;
}

.laborantes-actions-row {
    display: flex;
    justify-content: flex-end;
}

.laborantes-primary-btn {
    min-height: 46px;
    border: 0;
    border-radius: 0.45rem;
    background: #cc7d39 !important;
    font-weight: 700;
}

.laborantes-secondary-btn {
    min-height: 36px;
    border: 0;
    border-radius: 0.45rem;
    background: #cc7d39 !important;
    font-weight: 700;
}

.laborantes-delete-col {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-top: 0;
    min-width: 52px;
}

.laborantes-delete-btn {
    min-width: 40px;
    min-height: 36px;
    border-radius: 0.45rem;
}

.laborantes-toggle-row {
    margin-top: 0.55rem;
}

.laborantes-table-wrap {
    border: 1px solid #e8edf4;
    border-radius: 0.85rem;
    background: #fff;
}

.laborantes-table-wrap .table {
    margin-bottom: 0;
}

.laborantes-table-wrap thead th {
    color: #31384c;
    font-weight: 800;
    border-top: 0;
    white-space: nowrap;
}

:deep(.multiselect__tags),
:deep(.mx-input) {
    border-radius: 0.45rem;
    min-height: 38px;
}

:deep(.multiselect__tags) {
    border-color: #d8dee8;
}

:deep(.mx-datepicker) {
    width: 100%;
}

:deep(.mx-input) {
    width: 100%;
    border: 1px solid #d8dee8;
}

@media (max-width: 991px) {
    .laborantes-entry-row {
        grid-template-columns: minmax(220px, 1.4fr) minmax(150px, 1fr) minmax(150px, 1fr);
    }

    .laborantes-delete-col {
        grid-column: 1 / -1;
        justify-content: flex-end;
        margin-top: -0.1rem;
    }

    .laborantes-section-card {
        padding: 1rem 0.85rem 0.55rem;
    }

    .laborantes-delete-col {
        padding-top: 0.15rem;
        margin-bottom: 0.75rem;
    }

    .laborantes-delete-btn {
        min-width: 44px;
    }

    .laborantes-actions-row .btn,
    .laborantes-primary-btn {
        width: 100%;
    }

    .laborantes-actions-row {
        justify-content: stretch;
    }
}

@media (max-width: 767px) {
    .laborantes-evento-body {
        padding: 0.75rem;
    }

    .laborantes-entry-row {
        grid-template-columns: 1fr;
        row-gap: 0.2rem;
    }

    .laborantes-section-title {
        font-size: 0.98rem;
    }

    .laborantes-entry-row {
        margin-bottom: 0.8rem;
        padding-bottom: 0.4rem;
        border-bottom: 1px dashed #e7ebf3;
    }

    .laborantes-entry-row:last-of-type {
        border-bottom: 0;
        padding-bottom: 0;
    }

    .laborantes-label-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.1rem;
    }

    .laborantes-delete-col {
        justify-content: stretch;
        grid-column: auto;
    }

    .laborantes-delete-btn {
        width: 100%;
    }

    .laborantes-table-wrap {
        border-radius: 0.65rem;
    }
}
</style>
